import {Box, Typography} from "@mui/material";
import {c, mono, maxW, section} from "../landingTokens";

const STEPS = [
  {n: "01", title: "Instant call routing", body: "Your AI greets callers in under a second. No hold, no queue, no frustration."},
  {n: "02", title: "Smart intent detection", body: "Natural language understanding covers 100+ needs — billing, support, returns and more."},
  {n: "03", title: "Automated resolution", body: "Handles 60–70% of routine calls end to end: refunds, hours, order tracking, appointments."},
  {n: "04", title: "Seamless human handoff", body: "Escalates complex issues to an agent with the full transcript and context attached."},
];

export const HowItWorks = () => (
  <Box component="section" id="how" data-screen-label="How it works" sx={{px: section.px, pb: section.pb}}>
    <Box
      sx={{
        maxWidth: maxW,
        mx: "auto",
        background: `linear-gradient(135deg, #DCEBFA 0%, ${c.purple} 52%, ${c.purpleInk} 100%)`,
        borderRadius: "36px",
        p: "clamp(32px, 5vw, 68px)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box aria-hidden sx={{position: "absolute", top: -120, right: -80, width: 420, height: 420, borderRadius: "50%", bgcolor: "rgba(255,255,255,0.16)"}} />
      <Box aria-hidden sx={{position: "absolute", bottom: -140, left: -100, width: 340, height: 340, borderRadius: "50%", bgcolor: "rgba(255,255,255,0.14)"}} />

      <Box sx={{position: "relative"}}>
        <Typography sx={{fontFamily: mono, fontSize: "11.5px", letterSpacing: "0.16em", textTransform: "uppercase", color: "rgba(255,255,255,0.8)", mb: 2.25}}>
          How it works
        </Typography>
        <Typography component="h2" sx={{fontSize: "clamp(32px, 4.6vw, 56px)", lineHeight: 1.05, letterSpacing: "-0.035em", fontWeight: 600, color: c.white, maxWidth: 760, mb: 1.75, textWrap: "balance"}}>
          AI that works like your best agent — instantly.
        </Typography>
        <Typography sx={{fontSize: 18, lineHeight: 1.5, color: "rgba(255,255,255,0.86)", maxWidth: 560, mb: 5.75}}>
          Four steps between the ring and a resolved request.
        </Typography>

        <Box sx={{display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(230px, 1fr))", gap: 2}}>
          {STEPS.map((s) => (
            <Box
              key={s.n}
              sx={{
                bgcolor: "rgba(255,255,255,0.16)",
                backdropFilter: "blur(6px)",
                border: "1px solid rgba(255,255,255,0.3)",
                borderRadius: "24px",
                p: 3,
                transition: "transform 200ms ease, background-color 200ms ease",
                "&:hover": {transform: "translateY(-4px)", bgcolor: "rgba(255,255,255,0.24)"},
              }}
            >
              <Typography sx={{fontFamily: mono, fontSize: "11.5px", color: c.white, opacity: 0.75}}>{s.n}</Typography>
              <Typography sx={{fontSize: 19, letterSpacing: "-0.015em", fontWeight: 600, color: c.white, mt: 1.75, mb: 1}}>{s.title}</Typography>
              <Typography sx={{fontSize: "14.5px", lineHeight: 1.5, color: "rgba(255,255,255,0.9)"}}>{s.body}</Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  </Box>
);
